<template>
  <div ref="mapRef" class="mapBox"></div>
  <div class="mapBox mainBox">
    <nyTit pathUrl="/qixiang"  :nextShow="false" />

    <div class="analysis-map-legend">
      <div v-for="item in analysisMapLegendItems" :key="item.label">
        <i :style="{ background: item.color }"></i>
        <span>{{ item.label }}</span>
      </div>
    </div>

    <div class="map-zoom-tools">
      <button type="button" title="放大地图" @click.stop="zoomMap(1)">＋</button>
      <button type="button" title="还原视角" @click.stop="resetMapView">复位</button>
      <button type="button" title="缩小地图" @click.stop="zoomMap(-1)">－</button>
    </div>

    <div class="content">
      <section class="analysis-panel left-panel">
        <div class="tech-card stats-card">
          <PanelTitle title="全域数据统计看板" subtitle="空间监测指标一览" />
          <div class="stats-grid">
            <div class="metric-box">
              <div class="metric-label">监测地块</div>
              <div class="metric-value">1286<span>个</span></div>
              <div ref="monitorBarRef" class="chart metric-chart"></div>
            </div>
            <div class="metric-box coverage-box">
              <div ref="coveragePieRef" class="chart metric-chart coverage-chart"></div>
            </div>
            <!-- <div class="metric-box">
              <div class="metric-label">异常线索</div>
              <div class="metric-value">42<span>条</span></div>
              <div ref="cluePieRef" class="chart metric-chart"></div>
            </div> -->
            <!-- <div class="metric-box">
              <div class="metric-label">处置完成率</div>
              <div class="metric-value">91.8<span>%</span></div>
              <div ref="finishLineRef" class="chart metric-chart"></div>
            </div> -->
          </div>
          <!-- <div class="panel-footer">数据更新时间：今日 08:30</div> -->
        </div>

        <div class="tech-card preprocess-card">
          <PanelTitle title="卫星影像预处理状态" subtitle="图层运行 | 影像优化 | 同步更新" />
          <div class="preprocess-body">
            <div class="status-tower">
              <div class="toggle-light"><i></i><i></i><i></i></div>
              <p>图层运行状态：<b>正常在线轮询</b></p>
            </div>
            <div class="process-main">
              <div class="process-steps">
                <div>云层去除：自动完成</div>
                <span></span>
                <div>雾霾削弱优化：已增强</div>
                <span></span>
                <div>影像切片发布：已同步</div>
              </div>
              <div class="date-card">
                <p>最新影像更新日期：<b>{{ latestDate }}</b></p>
                <p>动态同步至监测周期</p>
                <p>图层服务状态：<b>稳定</b></p>
              </div>
            </div>
          </div>
          <div class="panel-footer">今日批次 12次　　　　云层占比 3.2%</div>
        </div>

        <div class="tech-card ledger-card">
          <PanelTitle title="上蔡县业务台账卫星图层" subtitle="卫星底图与业务台账数据空间关联" />
          <div class="ledger-body">
            <div class="satellite-visual">
              <img src="../assets/img/map2.png" alt="上蔡县卫星图层" />
              <div class="county-mask"></div>
            </div>
            <div class="ledger-list">
              <div v-for="item in ledgerRows" :key="item.name">
                <span>{{ item.name }}</span>
                <b>{{ item.value }}</b>
              </div>
            </div>
          </div>
        </div>

        <div class="tech-card anomaly-card">
          <PanelTitle title="地块异常、违建、作物胁迫实时识别" subtitle="AI变化检测与遥感特征智能研判" />
          <div class="anomaly-body">
            <div class="anomaly-types">
              <div v-for="item in anomalyTypes" :key="item.title">
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </div>
            <div class="sync-board">
              <!-- <h3>今日同步频次</h3>
              <strong>12<span>次</span></strong> -->
              <div ref="syncPieRef" class="chart sync-chart"></div>
              <!-- <div class="sync-counts">
                <p><i class="cyan"></i>蓝色关注 <b>12次</b></p>
                <p><i class="yellow"></i>黄色预警 <b>38项</b></p>
                <p><i class="red"></i>红色告警 <b>38项</b></p>
              </div> -->
            </div>
          </div>
          <div class="panel-footer">今日识别线索 42条　　高优先级 8条</div>
        </div>
      </section>

      <section class="analysis-panel right-panel">
        <div class="tech-card overview-card">
          <PanelTitle title="综合态势总览" subtitle="全域监测指标与处置进度" />
          <div class="overview-body">
            <div class="overview-kpis">
              <div v-for="item in overviewStats" :key="item.label">
                <span>{{ item.label }}</span>
                <b>{{ item.value }}</b>
              </div>
            </div>
            <div class="overview-progress">
              <div ref="overviewPieRef" class="chart overview-chart"></div>
            </div>
          </div>
          <div class="panel-footer">农业监测 | 国土监管 | 乡村治理 | 卫星更新</div>
        </div>

        <div class="tech-card closed-card">
          <PanelTitle title="分级预警闭环管理" subtitle="发现异常 | 智能研判 | 处置跟踪" />
          <div class="closed-flow">
            <img src="../assets/img/right1.png" />
          </div>
        </div>

        <div class="tech-card push-card">
          <PanelTitle title="分级分类预警推送机制" subtitle="按风险等级、业务类型与责任主体精准触达" />
          <div class="push-body">
            <div class="risk-levels">
              <div class="blue">蓝色关注：持续监测</div>
              <div class="yellow">黄色预警：核实处置</div>
              <div class="amber">橙色预警：限时处置</div>
              <div class="red">红色告警：立即乡镇督办</div>
            </div>
            <div class="business-class">
              <h3>业务分类</h3>
              <div v-for="item in businessRows" :key="item.name">
                <span>{{ item.name }}</span>
                <p>{{ item.desc }}</p>
              </div>
            </div>
            <div class="delivery-box">
              <p>平台告警 | 短信通知</p>
              <p>任务派单 | 乡镇签收</p>
              <p>现场核验 | 处置反馈</p>
              <p>复核销号 | 台账归档</p>
            </div>
          </div>
          <div class="panel-footer">今日推送 18项　　已签收 15项　　待确认 3项</div>
        </div>

        <div class="tech-card disposal-card">
          <PanelTitle title="问题上报-研判-处置销号告警闭环管理" subtitle="从发现问题到归档反馈的全流程跟踪" />
          <div class="disposal-flow">
            <img src="../assets/img/right2.png" />
            <!-- <div class="step-card top-step">
              <h3>问题上报</h3>
              <p>遥感发现、现场核实、线索登记</p>
            </div>
            <div class="step-card top-step">
              <h3>智能研判</h3>
              <p>风险分级、责任匹配、时限判定</p>
            </div>
            <div class="step-card top-step">
              <h3>处置派单</h3>
              <p>任务下发、责任匹配、时限判定</p>
            </div>
            <div class="step-card wide-step">
              <h3>处置派单</h3>
              <p>任务下发、部门协同、过程跟踪</p>
            </div>
            <div class="step-card wide-step">
              <h3>销号归档</h3>
              <p>结果反馈、复核关闭、台账归档</p>
            </div> -->
          </div>
          <div class="panel-footer">处置完成率 90.5%　　待复核 4项　　已归档 38项</div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { h, ref, onMounted, onUnmounted, nextTick } from "vue";
import nyTit from "@/components/nyTit";
import * as echarts from "echarts";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Gep from "../utils/范围面.json";

const PanelTitle = (props) =>
  h("div", { class: "panel-heading" }, [
    h("div", { class: "heading-main" }, props.title),
    h("div", { class: "heading-sub" }, props.subtitle),
  ]);

PanelTitle.props = {
  title: String,
  subtitle: String,
};

const mapRef = ref(null);
const map = ref(null);
const mapObj = ref(null);
const boundaryData = Gep;
const defaultMapView = {
  center: [33.248258780732435, 114.18800353654662],
  zoom: 15,
};
const chartInstances = [];

const monitorBarRef = ref(null);
const coveragePieRef = ref(null);
const cluePieRef = ref(null);
const finishLineRef = ref(null);
const syncPieRef = ref(null);
const overviewPieRef = ref(null);

const latestDate = new Date().toLocaleDateString("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
}).replace(/\//g, "-");

const ledgerRows = [
  { name: "耕地台账", value: "36.5万亩" },
  { name: "地块台账", value: "1286个" },
  { name: "图斑台账", value: "1564个" },
  { name: "监测台账", value: "42条" },
  { name: "巡查台账", value: "46条" },
  { name: "处置台账", value: "38条" },
  { name: "复核台账", value: "4条" },
];

const anomalyTypes = [
  { title: "地块异常", desc: "边界变化、面积变化、闲置变化" },
  { title: "违建线索", desc: "疑似违建、占用地块、边界越界" },
  { title: "作物胁迫", desc: "干旱胁迫、病虫害、长势异常" },
  // { title: "边界变化", desc: "面积变化、闲置变化" },
  { title: "复核派单", desc: "线索核验、责任派单、闭环跟踪" },
];

const overviewStats = [
  { label: "监测区域", value: "28个" },
  { label: "预警事件", value: "42起" },
  { label: "处置完成", value: "38起" },
  { label: "待复核", value: "4起" },
  { label: "闭环率", value: "90.5%" },
  { label: "今日同步", value: "12次" },
];

const businessRows = [
  { name: "农业监测", desc: "作物胁迫、墒情异常" },
  { name: "国土监管", desc: "疑似违建、地块变化" },
  { name: "水系巡查", desc: "河渠变化、占压堵点" },
  { name: "乡村治理", desc: "事件上报、处置督办" },
];

const analysisMapLegendItems = [
  { label: "监测网格", color: "rgba(64, 255, 215, 0.88)" },
  { label: "预警热区", color: "rgba(255, 116, 92, 0.88)" },
  { label: "线索点位", color: "rgba(255, 214, 92, 0.88)" },
  { label: "分析流向", color: "rgba(98, 182, 255, 0.88)" },
];

const analysisGridAreas = [
  {
    name: "农业监测网格A",
    color: "#40ffd7",
    coordinates: [
      [33.2588, 114.1724],
      [33.2582, 114.1856],
      [33.2512, 114.1888],
      [33.2467, 114.1794],
      [33.2508, 114.1696],
    ],
  },
  {
    name: "国土监测网格B",
    color: "#56e7ff",
    coordinates: [
      [33.2515, 114.1914],
      [33.2492, 114.2053],
      [33.2419, 114.2072],
      [33.2395, 114.1945],
      [33.2449, 114.1888],
    ],
  },
  {
    name: "水系巡查网格C",
    color: "#62b6ff",
    coordinates: [
      [33.2634, 114.1781],
      [33.2601, 114.1854],
      [33.2551, 114.1914],
      [33.2508, 114.1984],
      [33.2484, 114.1964],
      [33.2541, 114.1887],
      [33.2585, 114.1837],
    ],
  },
];

const analysisWarningAreas = [
  {
    name: "红色告警热区",
    color: "#ff745c",
    coordinates: [
      [33.2491, 114.1981],
      [33.2478, 114.2028],
      [33.2441, 114.2024],
      [33.2434, 114.1973],
      [33.2463, 114.1948],
    ],
  },
  {
    name: "黄色预警热区",
    color: "#ffd65c",
    coordinates: [
      [33.2552, 114.1781],
      [33.2546, 114.1847],
      [33.2508, 114.1855],
      [33.2488, 114.1802],
      [33.2518, 114.1755],
    ],
  },
];

const analysisCluePoints = [
  { name: "作物胁迫线索", level: "yellow", coord: [33.2536, 114.1816], value: "待核验" },
  { name: "疑似地块变化", level: "red", coord: [33.2461, 114.1992], value: "高优先级" },
  { name: "河渠占压疑点", level: "blue", coord: [33.2572, 114.1904], value: "持续监测" },
  { name: "村镇边界变化", level: "yellow", coord: [33.2433, 114.2042], value: "待复核" },
  { name: "耕地边界偏移", level: "blue", coord: [33.2495, 114.1749], value: "自动比对" },
];

const analysisFlowLines = [
  {
    name: "线索推送链路",
    color: "#62b6ff",
    coordinates: [
      [33.2536, 114.1816],
      [33.2509, 114.1874],
      [33.2461, 114.1992],
    ],
  },
  {
    name: "水系巡查链路",
    color: "#40ffd7",
    coordinates: [
      [33.2572, 114.1904],
      [33.2541, 114.1938],
      [33.2508, 114.1984],
    ],
  },
];

const clueLevelMeta = {
  red: { label: "红", color: "#ff745c" },
  yellow: { label: "黄", color: "#ffd65c" },
  blue: { label: "蓝", color: "#62b6ff" },
};

const mapType1 = ref(
  L.tileLayer(
    "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
      opacity: 0.88,
      pane: "analysisRasterPane",
      className: "analysis-satellite-tile",
    }
  )
);

const mapLabelType1 = ref(
  L.tileLayer(
    "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
      opacity: 0.82,
      pane: "analysisLabelPane",
    }
  )
);

const initMap = () => {
  map.value.createPane("analysisRasterPane");
  map.value.getPane("analysisRasterPane").style.zIndex = 350;
  map.value.createPane("analysisThematicPane");
  map.value.getPane("analysisThematicPane").style.zIndex = 370;
  map.value.createPane("analysisMarkerPane");
  map.value.getPane("analysisMarkerPane").style.zIndex = 390;
  map.value.createPane("analysisLabelPane");
  map.value.getPane("analysisLabelPane").style.zIndex = 400;
  map.value.addLayer(mapType1.value);
  map.value.addLayer(mapLabelType1.value);
  return map.value;
};

function zoomMap(delta) {
  if (!map.value) return;
  if (delta > 0) {
    map.value.zoomIn(1);
  } else {
    map.value.zoomOut(1);
  }
}

function resetMapView() {
  if (!map.value) return;
  map.value.setView(defaultMapView.center, defaultMapView.zoom);
}

function createClueIcon(level) {
  const meta = clueLevelMeta[level] || clueLevelMeta.blue;
  return L.divIcon({
    className: "analysis-clue-marker",
    html: `<span style="--marker-color:${meta.color}">${meta.label}</span>`,
    iconSize: [58, 58],
    iconAnchor: [29, 29],
  });
}

function createDashedPolyline(coordinates, style) {
  const latLngs = coordinates.map(([lng, lat]) => [lat, lng]);
  return L.polyline(latLngs, {
    ...style,
    dashArray: [5, 5],
    lineCap: "round",
    lineJoin: "round",
  });
}

const loadBoundary = () => {
  L.geoJSON(boundaryData, {
    onEachFeature(feature, layer) {
      const style = {
        color: "#D1E211",
        fillColor: "#226FC1",
        fillOpacity: 0,
        dashArray: [1, 1],
        weight: 1,
      };

      if (feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon") {
        layer.setStyle(style);
        const rings =
          feature.geometry.type === "Polygon"
            ? [feature.geometry.coordinates[0]]
            : feature.geometry.coordinates.map((polygon) => polygon[0]);
        rings.forEach((ring) => map.value.addLayer(createDashedPolyline(ring, style)));
      } else if (feature.geometry.type === "LineString" || feature.geometry.type === "MultiLineString") {
        const coordinates =
          feature.geometry.type === "LineString"
            ? feature.geometry.coordinates
            : feature.geometry.coordinates[0];
        map.value.addLayer(createDashedPolyline(coordinates, style));
      }

      map.value.addLayer(layer);
    },
  }).addTo(map.value);
};

function loadSpatialAnalysisLayer() {
  analysisGridAreas.forEach((area) => {
    L.polygon(area.coordinates, {
      pane: "analysisThematicPane",
      color: area.color,
      weight: 2.5,
      opacity: 0.85,
      fillColor: area.color,
      fillOpacity: 0.045,
      dashArray: "8 8",
      lineJoin: "round",
    })
      .bindTooltip(area.name, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "analysis-map-tooltip",
      })
      .addTo(map.value);
  });

  analysisWarningAreas.forEach((area) => {
    L.polygon(area.coordinates, {
      pane: "analysisThematicPane",
      color: area.color,
      weight: 3.2,
      opacity: 0.9,
      fillColor: area.color,
      fillOpacity: 0.11,
      dashArray: "5 7",
      lineJoin: "round",
    })
      .bindTooltip(area.name, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "analysis-map-tooltip",
      })
      .addTo(map.value);
  });

  analysisFlowLines.forEach((line) => {
    L.polyline(line.coordinates, {
      pane: "analysisThematicPane",
      color: line.color,
      weight: 5,
      opacity: 0.78,
      dashArray: "14 10",
      lineCap: "round",
      lineJoin: "round",
    })
      .bindTooltip(line.name, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "analysis-map-tooltip",
      })
      .addTo(map.value);
  });

  analysisCluePoints.forEach((point) => {
    L.marker(point.coord, {
      pane: "analysisMarkerPane",
      icon: createClueIcon(point.level),
      title: point.name,
    })
      .bindTooltip(`<b>${point.name}</b><br>${point.value}`, {
        permanent: false,
        sticky: true,
        direction: "top",
        className: "analysis-map-tooltip",
      })
      .addTo(map.value);
  });
}

function addChart(el, option) {
  if (!el) return;
  const chart = echarts.init(el);
  chart.setOption(option);
  chartInstances.push(chart);
  setTimeout(() => chart.resize(), 80);
}

function ringOption(data, colors, centerText, chartConfig = {}) {
  const centerStyle = Array.isArray(centerText)
    ? {
        text: `{title|${centerText[0]}}\n{value|${centerText[1]}}`,
        rich: {
          title: {
            fill: "#eafffb",
            fontSize: chartConfig.titleFontSize || 28,
            fontWeight: 900,
            lineHeight: chartConfig.titleLineHeight || 38,
          },
          value: {
            fill: "#ffffff",
            fontSize: chartConfig.valueFontSize || 36,
            fontWeight: 900,
            lineHeight: chartConfig.valueLineHeight || 48,
          },
        },
      }
    : {
        text: centerText,
        fill: "#eafffb",
        fontSize: chartConfig.fontSize || 24,
        fontWeight: 900,
      };

  return {
    color: colors,
    tooltip: {
      trigger: "item",
      textStyle: { fontSize: 22 },
    },
    legend: chartConfig.legend
      ? {
          itemWidth: 18,
          itemHeight: 12,
          itemGap: 26,
          textStyle: {
            color: "#eafffb",
            fontSize: 26,
            fontWeight: 800,
          },
          ...chartConfig.legend,
        }
      : undefined,
    graphic: centerText
      ? {
          type: "text",
          left: chartConfig.graphicLeft || "center",
          top: chartConfig.graphicTop || "center",
          style: {
            textAlign: "center",
            textVerticalAlign: "middle",
            ...centerStyle,
          },
        }
      : null,
    series: [
      {
        type: "pie",
        radius: chartConfig.radius || ["52%", "74%"],
        center: chartConfig.center || ["50%", "52%"],
        startAngle: 90,
        avoidLabelOverlap: true,
        label: {
          color: "#f4fffb",
          fontSize: chartConfig.labelFontSize || 22,
          formatter: chartConfig.labelFormatter || "{d}%",
          position: chartConfig.labelPosition || "outside",
          ...chartConfig.label,
        },
        labelLine: {
          show: chartConfig.labelLineShow !== false,
          length: 16,
          length2: 10,
          lineStyle: { color: "rgba(150,255,239,0.8)" },
          ...chartConfig.labelLine,
        },
        itemStyle: {
          borderColor: "rgba(2, 34, 31, 0.95)",
          borderWidth: 4,
          borderRadius: 6,
        },
        data,
      },
    ],
  };
}

function initCharts() {
  const axisColor = "rgba(224, 255, 250, 0.86)";
  const splitColor = "rgba(88, 255, 231, 0.18)";
  const tealGradient = new echarts.graphic.LinearGradient(0, 1, 0, 0, [
    { offset: 0, color: "#0a6f67" },
    { offset: 0.55, color: "#23e8cd" },
    { offset: 1, color: "#affff2" },
  ]);

  addChart(monitorBarRef.value, {
    tooltip: { trigger: "axis", textStyle: { fontSize: 22 } },
    legend: {
      top: 2,
      itemWidth: 20,
      itemHeight: 10,
      textStyle: { color: axisColor, fontSize: 22 },
      data: ["农业监测", "AI巡检", "线索处置"],
    },
    grid: { left: 45, right: 10, top: 52, bottom: 36 },
    xAxis: {
      type: "category",
      data: ["1月", "2月", "3月", "4月", "5月", "6月"],
      axisLabel: { color: axisColor, fontSize: 22 },
      axisTick: { show: false },
      axisLine: { lineStyle: { color: splitColor } },
    },
    yAxis: {
      type: "value",
      axisLabel: { color: axisColor, fontSize: 22 },
      splitLine: { lineStyle: { color: splitColor, type: "dashed" } },
    },
    series: [
      { name: "农业监测", type: "bar", barGap: '100%', barWidth: 12, data: [28, 34, 39, 46, 52, 58], itemStyle: { color: "#5df6e0" } },
      { name: "AI巡检", type: "bar", barGap: '100%', barWidth: 12, data: [18, 24, 31, 36, 39, 42], itemStyle: { color: "#7fdcff" } },
      { name: "线索处置", type: "bar", barGap: '100%', barWidth: 12, data: [12, 18, 23, 28, 34, 38], itemStyle: { color: "#f6c85f" } },
    ],
  });

  addChart(coveragePieRef.value, ringOption(
    [
      { value: 78, name: "耕地监测" },
      { value: 14, name: "村镇建设" },
      { value: 8, name: "河渠水系" },
    ],
    ["#3df0dc", "#ffce6f", "#79dbff"],
    ["覆盖面积", "36.5万亩"],
    {
      radius: ["38%", "56%"],
      center: ["50%", "44%"],
      graphicTop: "38%",
      titleFontSize: 26,
      titleLineHeight: 10,
      valueFontSize: 30,
      valueLineHeight: 66,
      legend: {
        data: ["耕地监测", "村镇建设", "河渠水系"],
        bottom: 20,
        left: "center",
        itemWidth: 18,
        itemHeight: 12,
        itemGap: 26,
        textStyle: {
          color: "#eafffb",
          fontSize: 26,
          fontWeight: 800,
        },
      },
    }
  ));

  addChart(cluePieRef.value, ringOption(
    [
      { value: 61, name: "农业线索" },
      { value: 27, name: "国土监管" },
      { value: 12, name: "乡村治理" },
    ],
    ["#2de9d2", "#ffcf73", "#ff7f6f"],
    "线索"
  ));

  addChart(finishLineRef.value, {
    tooltip: { trigger: "axis", textStyle: { fontSize: 22 } },
    grid: { left: 42, right: 15, top: 28, bottom: 34 },
    xAxis: {
      type: "category",
      data: ["08:00", "10:00", "12:00", "14:00", "16:00", "18:00"],
      axisLabel: { color: axisColor, fontSize: 22 },
      axisTick: { show: false },
      axisLine: { lineStyle: { color: splitColor } },
    },
    yAxis: {
      type: "value",
      min: 70,
      max: 100,
      axisLabel: { color: axisColor, fontSize: 22 },
      splitLine: { lineStyle: { color: splitColor, type: "dashed" } },
    },
    series: [
      {
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 10,
        data: [76, 80, 84, 88, 90, 91.8],
        lineStyle: { width: 5, color: "#63ffe5" },
        itemStyle: { color: "#f5ffff" },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(99,255,229,0.55)" },
            { offset: 1, color: "rgba(99,255,229,0.02)" },
          ]),
        },
      },
    ],
  });

  addChart(syncPieRef.value, ringOption(
    [
      { value: 22, name: "蓝色关注" },
      { value: 12, name: "黄色预警" },
      { value: 8, name: "红色告警" },
    ],
    ["#41e9ff", "#f2c25d", "#ff765f"],
    "42条",
     {
      radius: ["38%", "56%"],
      center: ["52%", "40%"],
      graphicLeft: "43%",
      graphicTop: "38%",
      labelLineShow: false,
      labelFormatter: "{c}",
      labelFontSize: 26,
      labelPosition: "inside",
      // titleFontSize: 26,
      // titleLineHeight: 10,
      // valueFontSize: 30,
      // valueLineHeight: 66,
     legend: {
        data: ["蓝色关注", "黄色预警", "红色告警"],
        bottom: 20,
        left: "center",
        itemWidth: 22,
        itemHeight: 12,
        itemGap: 26,
        textStyle: {
          color: "#eafffb",
          fontSize: 26,
          fontWeight: 800,
        },
      },
    }
  ));

  addChart(overviewPieRef.value, ringOption(
    [
      { value: 38, name: "已处置" },
      { value: 4, name: "待复核" },
    ],
    ["#4cffd6", "#f2c25d"],
    ["处置完成率", "90.5%"],
    {
      radius: ["38%", "56%"],
      center: ["40%", "48%"],
      graphicLeft: "30%",
      graphicTop: "42%",
      titleFontSize: 26,
      titleLineHeight: 10,
      valueFontSize: 30,
      valueLineHeight: 66,
      legend: {
        data: ["已处置", "待复核"],
        orient: "vertical",
        right: 10,
        top: "middle",
        width: 150,
        height: 150,
        align: "left",
        itemWidth: 18,
        itemHeight: 12,
        itemGap: 28,
        textStyle: {
          color: "#eafffb",
          fontSize: 26,
          fontWeight: 800,
        },
      },
    }
  ));
}

function resizeCharts() {
  chartInstances.forEach((chart) => chart.resize());
}

const removeMap = () => {
  if (mapObj.value) {
    mapObj.value.remove();
    mapObj.value = null;
    map.value = null;
  }
};

onMounted(() => {
  map.value = L.map(mapRef.value, {
    center: defaultMapView.center,
    zoom: defaultMapView.zoom,
    minZoom: 3,
    maxZoom: 19,
    noWrap: true,
    zoomControl: false,
    zoomSnap: 0.5,
    zoomDelta: 0.5,
    wheelPxPerZoomLevel: 80,
    scrollWheelZoom: true,
    doubleClickZoom: true,
    touchZoom: true,
    dragging: true,
    attributionControl: false,
  });

  mapObj.value = initMap();
  loadBoundary();
  loadSpatialAnalysisLayer();
  nextTick(initCharts);
  window.addEventListener("resize", resizeCharts);
});

onUnmounted(() => {
  window.removeEventListener("resize", resizeCharts);
  chartInstances.forEach((chart) => chart.dispose());
  chartInstances.length = 0;
  removeMap();
});
</script>

<style lang="less" scoped>
.mapBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.mainBox {
  width: 100%;
  height: 100%;
  background: url(../../src/assets/img/map_bg.png);
  background-size: cover;
  position: relative;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
  color: #f2fffb;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

.mainBox :deep(.titleBg) {
  pointer-events: auto;
}

.mapBox :deep(.analysis-satellite-tile) {
  filter: brightness(0.75) contrast(1.18) saturate(1.18) hue-rotate(8deg);
}

.mapBox :deep(.leaflet-overlay-pane svg path) {
  filter: drop-shadow(0 0 4px rgba(72, 255, 232, 0.44));
}

.analysis-map-legend {
  position: absolute;
  left: 50%;
  bottom: 92px;
  z-index: 8;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 22px;
  padding: 16px 26px;
  box-sizing: border-box;
  pointer-events: auto;
  background:
    linear-gradient(180deg, rgba(4, 70, 69, 0.72), rgba(2, 32, 35, 0.86)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.08) 0, rgba(61, 255, 234, 0.08) 1px, transparent 1px, transparent 24px);
  border: 1px solid rgba(76, 255, 235, 0.58);
  box-shadow: inset 0 0 22px rgba(48, 255, 226, 0.18), 0 0 20px rgba(38, 255, 231, 0.18);
  clip-path: polygon(16px 0, calc(100% - 16px) 0, 100% 16px, 100% calc(100% - 16px), calc(100% - 16px) 100%, 16px 100%, 0 calc(100% - 16px), 0 16px);
}

.analysis-map-legend div {
  display: flex;
  align-items: center;
  color: #eafffb;
  font-size: 26px;
  line-height: 34px;
  font-weight: 800;
  white-space: nowrap;
}

.analysis-map-legend i {
  width: 34px;
  height: 16px;
  margin-right: 10px;
  border: 1px solid rgba(255, 255, 255, 0.58);
  box-shadow: 0 0 12px currentColor;
}

.map-zoom-tools {
  position: absolute;
  left: 46%;
  top: 230px;
  z-index: 9;
  transform: translateX(520px);
  display: grid;
  grid-template-columns: 80px 80px 80px;
  gap: 20px;
  pointer-events: auto;
}

.map-zoom-tools button {
  width: 80px;
  height: 70px;
  border: 1px solid rgba(96, 255, 238, 0.78);
  color: #eafffb;
  font-size: 30px;
  line-height: 1;
  // font-weight: 900;
  cursor: pointer;
  background:
    linear-gradient(180deg, rgba(8, 92, 88, 0.58), rgba(3, 42, 43, 0.9)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.08) 0, rgba(61, 255, 234, 0.08) 1px, transparent 1px, transparent 18px);
  box-shadow: inset 0 0 18px rgba(52, 255, 231, 0.2), 0 0 16px rgba(52, 255, 231, 0.18);
  clip-path: polygon(10px 0, calc(100% - 10px) 0, 100% 10px, 100% calc(100% - 10px), calc(100% - 10px) 100%, 10px 100%, 0 calc(100% - 10px), 0 10px);
}

.map-zoom-tools button:hover {
  color: #ffffff;
  border-color: rgba(175, 255, 247, 0.96);
  background:
    linear-gradient(180deg, rgba(17, 126, 116, 0.92), rgba(4, 58, 58, 0.92)),
    repeating-linear-gradient(90deg, rgba(61, 255, 234, 0.1) 0, rgba(61, 255, 234, 0.1) 1px, transparent 1px, transparent 18px);
}

.mapBox :deep(.analysis-clue-marker) {
  background: transparent;
  border: none;
}

.mapBox :deep(.analysis-clue-marker span) {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 25px;
  line-height: 1;
  font-weight: 900;
  border: 2px solid var(--marker-color);
  border-radius: 50%;
  background: rgba(3, 35, 38, 0.76);
  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.08), 0 0 20px var(--marker-color), inset 0 0 16px rgba(255, 255, 255, 0.16);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.mapBox :deep(.analysis-map-tooltip) {
  padding: 8px 14px;
  color: #ffffff;
  font-size: 24px;
  font-weight: 900;
  line-height: 32px;
  letter-spacing: 0;
  background: rgba(3, 35, 38, 0.74);
  border: 1px solid rgba(129, 255, 240, 0.72);
  box-shadow: 0 0 18px rgba(63, 255, 234, 0.34);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.42);
}

.mapBox :deep(.analysis-map-tooltip::before) {
  display: none;
}

.content {
  position: absolute;
  top: 190px;
  left: 70px;
  right: 70px;
  height: calc(100% - 230px);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  pointer-events: auto;
}

.analysis-panel {
  width: 2100px;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 26px;
}

.tech-card {
  position: relative;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  padding: 20px 28px 18px;
  background:
    radial-gradient(circle at 50% 0, rgba(60, 255, 231, 0.2), transparent 34%),
    linear-gradient(135deg, rgba(2, 35, 31, 0.9), rgba(6, 45, 41, 0.72) 58%, rgba(2, 35, 31, 0.9)),
    repeating-linear-gradient(90deg, rgba(62, 255, 230, 0.04) 0, rgba(62, 255, 230, 0.04) 1px, transparent 1px, transparent 30px);
  border: 2px solid rgba(62, 255, 234, 0.28);
  clip-path: polygon(34px 0, calc(100% - 34px) 0, 100% 34px, 100% calc(100% - 34px), calc(100% - 34px) 100%, 34px 100%, 0 calc(100% - 34px), 0 34px);
  box-shadow: inset 0 0 44px rgba(44, 255, 225, 0.17), 0 0 18px rgba(42, 255, 225, 0.15);
  overflow: hidden;
  gap: 10px;
}

.tech-card::before,
.tech-card::after {
  content: "";
  position: absolute;
  height: 3px;
  top: 24px;
  width: 130px;
  background: linear-gradient(90deg, transparent, #99fff3, transparent);
  box-shadow: 0 0 16px rgba(121, 255, 242, 0.9);
}

.tech-card::before {
  left: 200px;
}

.tech-card::after {
  right: 200px;
}

.panel-heading {
  height: 112px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-shadow: 0 0 14px rgba(132, 255, 243, 0.2);
}

:deep(.heading-main) {
  position: relative;
  font-size: 42px;
  line-height: 54px;
  font-weight: 900;
}

:deep(.heading-main)::before,
:deep(.heading-main)::after {
  content: "";
  position: absolute;
  top: 22px;
  width: 86px;
  height: 6px;
  background: linear-gradient(90deg, #d9fff8, #69fff0);
  transform: skewX(26deg);
  box-shadow: 0 0 12px rgba(105, 255, 240, 0.8);
}

:deep(.heading-main)::before {
  left: -120px;
}

:deep(.heading-main)::after {
  right: -120px;
}

:deep(.heading-sub) {
  margin-top: 8px;
  color: #e3fff9;
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
}

.chart {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
}

.stats-card {
  display: grid;
  grid-template-rows: 130px 1fr;
  padding-bottom: 50px;
}

.stats-grid {
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.metric-box {
  min-width: 0;
  display: grid;
  grid-template-rows: 58px 70px minmax(0, 1fr);
  padding: 22px 14px 12px;
  box-sizing: border-box;
  background: rgba(0, 45, 40, 0.66);
  border: 1px solid rgba(116, 255, 239, 0.52);
  clip-path: polygon(20px 0, calc(100% - 20px) 0, 100% 20px, 100% calc(100% - 20px), calc(100% - 20px) 100%, 20px 100%, 0 calc(100% - 20px), 0 20px);
}

.coverage-box {
  grid-template-rows: minmax(0, 1fr);
  padding: 8px 8px 4px;
}

.metric-label {
  color: #ffffff;
  font-size: 30px;
  line-height: 44px;
  font-weight: 900;
  text-align: center;
}

.metric-value {
  color: #ffffff;
  font-size: 46px;
  line-height: 62px;
  font-weight: 900;
  text-align: center;
}

.metric-value span {
  margin-left: 4px;
  font-size: 30px;
}

.metric-chart {
  min-height: 190px;
}

.coverage-chart {
  min-height: 330px;
}

.panel-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e9fff9;
  font-size: 26px;
  line-height: 38px;
  font-weight: 800;
}

.preprocess-card {
  display: grid;
  grid-template-rows: 130px 1fr 60px;
  // gap: 20px;
}

.preprocess-body {
  min-height: 0;
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 30px;
  align-items: stretch;
}

.status-tower,
.process-main,
.date-card,
.ledger-list,
.sync-board,
.delivery-box,
.step-card {
  border: 1px solid rgba(117, 255, 241, 0.48);
  background: rgba(0, 49, 43, 0.62);
  box-shadow: inset 0 0 24px rgba(55, 255, 230, 0.11);
}

.status-tower {
  padding: 78px 28px 28px;
  box-sizing: border-box;
  clip-path: polygon(26px 0, calc(100% - 26px) 0, 100% 26px, 100% calc(100% - 26px), calc(100% - 26px) 100%, 26px 100%, 0 calc(100% - 26px), 0 26px);
}

.toggle-light {
  width: 110px;
  height: 30px;
  margin: 0 auto 48px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 20px;
  background: rgba(11, 118, 103, 0.66);
  border: 1px solid rgba(112, 255, 239, 0.6);
}

.toggle-light i {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(122, 255, 240, 0.35);
}

.toggle-light i:first-child {
  width: 56px;
  border-radius: 16px;
  background: linear-gradient(90deg, #bdfff7, #39f5d8);
  box-shadow: 0 0 18px rgba(69, 255, 228, 0.9);
}

.status-tower p,
.date-card p,
.process-steps div,
.anomaly-types p,
.sync-counts p,
.overview-progress p,
.push-body p,
.disposal-flow p {
  margin: 0;
  color: #e5fff9;
  font-size: 26px;
  line-height: 38px;
  font-weight: 700;
}

.status-tower b,
.date-card b {
  color: #ffffff;
  font-size: 26px;
}

.process-main {
  padding: 42px 34px;
  display: grid;
  grid-template-columns: 1fr 275px;
  gap: 28px;
  clip-path: polygon(28px 0, calc(100% - 28px) 0, 100% 28px, 100% calc(100% - 28px), calc(100% - 28px) 100%, 28px 100%, 0 calc(100% - 28px), 0 28px);
}

.process-steps {
  display: grid;
  grid-template-rows: repeat(5, auto);
  align-content: center;
  gap: 18px;
}

.process-steps div {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: linear-gradient(90deg, rgba(5, 102, 90, 0.86), rgba(12, 144, 121, 0.7));
  border-radius: 6px;
}

.process-steps span {
  width: 0;
  height: 0;
  margin: 0 auto;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 18px solid #71fff0;
  filter: drop-shadow(0 0 8px rgba(113, 255, 240, 0.8));
}

.date-card {
  padding: 44px 24px;
}

.ledger-card,
.anomaly-card,
.overview-card,
.push-card,
.disposal-card {
  display: grid;
  grid-template-rows: 130px 1fr 20px;
}
.anomaly-card,
.overview-card,
.push-card,
.disposal-card{
  grid-template-rows: 130px 1fr 44px;
}

.ledger-body {
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr  400px;
  gap: 30px;
}

.satellite-visual {
  position: relative;
  min-height: 0;
  border: 1px solid rgba(117, 255, 241, 0.48);
  overflow: hidden;
}

.satellite-visual img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.county-mask {
  position: absolute;
  left: 17%;
  top: 16%;
  width: 66%;
  height: 68%;
  background: rgba(38, 196, 179, 0.42);
  border: 3px solid rgba(153, 255, 241, 0.86);
  clip-path: polygon(6% 28%, 19% 12%, 44% 7%, 73% 15%, 92% 34%, 86% 74%, 60% 90%, 31% 84%, 10% 64%);
}

.map-tag {
  position: absolute;
  padding: 6px 12px;
  color: #ffffff;
  font-size: 26px;
  line-height: 34px;
  font-weight: 900;
  background: rgba(3, 85, 78, 0.78);
  border: 1px solid rgba(105, 255, 239, 0.62);
}

.tag-a { left: 24px; bottom: 78px; }
.tag-b { left: 290px; top: 208px; }
.tag-c { right: 24px; bottom: 116px; }
.tag-d { right: 88px; top: 180px; }

.layer-switch {
  min-width: 0;
  display: grid;
  grid-template-rows: repeat(7, 1fr);
  gap: 10px;
}

.switch-row,
.layer-switch button {
  min-width: 0;
  color: #eafffb;
  font-size: 26px;
  font-weight: 800;
  background: rgba(4, 82, 73, 0.74);
  border: 1px solid rgba(87, 255, 235, 0.44);
}

.switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
}

.switch-row b,
.layer-switch button.active {
  color: #7bfff0;
}

.layer-switch button {
  cursor: default;
}

.ledger-list {
  padding: 22px 20px;
  display: grid;
  grid-template-rows: repeat(7, 1fr);
  gap: 10px;
}

.ledger-list div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  color: #eafffb;
  font-size: 26px;
  line-height: 36px;
  background: rgba(8, 80, 71, 0.7);
  border-left: 4px solid rgba(68, 255, 228, 0.74);
}

.ledger-list b {
  color: #ffffff;
  font-size: 26px;
}

.anomaly-body {
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 24px;
}

.anomaly-types {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: 20px;
}

.anomaly-types div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  background: rgba(0, 49, 43, 0.62);
  border: 1px solid rgba(117, 255, 241, 0.48);
  clip-path: polygon(22px 0, calc(100% - 22px) 0, 100% 22px, 100% calc(100% - 22px), calc(100% - 22px) 100%, 22px 100%, 0 calc(100% - 22px), 0 22px);
}

.anomaly-types h3,
.sync-board h3,
.overview-progress h3,
.risk-box h3,
.dispatch-box h3,
.business-class h3,
.step-card h3 {
  margin: 0 0 12px;
  color: #ffffff;
  font-size: 30px;
  line-height: 42px;
  font-weight: 900;
}

.sync-board {
  padding: 20px;
  text-align: center;
}

.sync-board strong,
.overview-progress strong {
  color: #ffffff;
  font-size: 52px;
  line-height: 62px;
}

.sync-board strong span,
.overview-progress strong span {
  margin-left: 8px;
  font-size: 28px;
}

.sync-chart {
  min-height: 190px;
}

.sync-counts {
  text-align: left;
}

.sync-counts i {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
  border-radius: 50%;
}

.sync-counts .cyan { background: #41e9ff; }
.sync-counts .yellow { background: #f2c25d; }
.sync-counts .red { background: #ff765f; }

.sync-counts b,
.overview-progress b {
  color: #ffe77a;
  font-size: 30px;
}

.overview-body {
  min-height: 0;
  display: grid;
  grid-template-columns: 490px 1fr;
  gap: 28px;
}

.overview-kpis {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.overview-kpis div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 49, 43, 0.62);
  border: 1px solid rgba(117, 255, 241, 0.48);
  clip-path: polygon(22px 0, calc(100% - 22px) 0, 100% 22px, 100% calc(100% - 22px), calc(100% - 22px) 100%, 22px 100%, 0 calc(100% - 22px), 0 22px);
}

.overview-kpis span {
  color: #ffffff;
  font-size: 30px;
  line-height: 42px;
  font-weight: 900;
}

.overview-kpis b {
  color: #ffffff;
  font-size: 54px;
  line-height: 70px;
}

.overview-progress {
  padding: 20px 26px;
  background: rgba(0, 49, 43, 0.62);
  border: 1px solid rgba(117, 255, 241, 0.48);
}

.overview-chart {
  width: 100%;
  min-height: 250px;
}

.closed-card {
  display: grid;
  grid-template-rows: 130px 1fr;
}

.closed-flow {
  position: relative;
  img{
    width: 100%;
   
  }
}

.circle-node {
  position: absolute;
  left: 180px;
  top: 36px;
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dffff9;
  font-size: 30px;
  border-radius: 50%;
  border: 3px solid rgba(102, 255, 239, 0.82);
  box-shadow: 0 0 22px rgba(87, 255, 235, 0.38);
}

.circle-node.second {
  top: auto;
  bottom: 96px;
}

.flow-chip,
.flow-node,
.risk-box,
.dispatch-box,
.warn-box {
  position: absolute;
  box-sizing: border-box;
  color: #eafffb;
  font-size: 26px;
  line-height: 36px;
  font-weight: 800;
  background: rgba(0, 55, 49, 0.78);
  border: 1px solid rgba(112, 255, 240, 0.55);
  box-shadow: inset 0 0 24px rgba(55, 255, 230, 0.11);
}

.flow-chip {
  height: 46px;
  padding: 4px 18px;
}

.flow-chip.top {
  left: 300px;
  top: 40px;
}

.flow-node.identify {
  left: 40px;
  top: 190px;
  width: 140px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.risk-box {
  left: 240px;
  top: 130px;
  width: 420px;
  height: 155px;
  padding: 22px;
}

.dispatch-box {
  right: 225px;
  top: 130px;
  width: 245px;
  height: 155px;
  padding: 28px 18px;
  text-align: center;
}

.warn-box {
  right: 20px;
  top: 162px;
  width: 170px;
  padding: 14px 10px;
}

.warn-box p {
  font-size: 26px;
  line-height: 34px;
}

.flow-chip.bottom-a { left: 300px; bottom: 98px; }
.flow-chip.bottom-b { left: 520px; bottom: 98px; }
.flow-chip.bottom-c { right: 220px; bottom: 98px; }

.flow-line {
  position: absolute;
  left: 220px;
  right: 80px;
  top: 70px;
  height: 230px;
  border-top: 3px solid rgba(85, 255, 236, 0.42);
  border-right: 3px solid rgba(85, 255, 236, 0.42);
  border-radius: 0 120px 0 0;
}

.push-body {
  min-height: 0;
  display: grid;
  grid-template-columns: 180px 1fr 260px;
  gap: 24px;
  align-items: stretch;
}

.risk-levels {
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  gap: 12px;
}

.risk-levels div {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  color: #ffffff;
  font-size: 26px;
  line-height: 34px;
  font-weight: 900;
  text-align: center;
  border: 1px solid rgba(105, 255, 239, 0.5);
}

.risk-levels .blue { background: rgba(20, 178, 208, 0.42); }
.risk-levels .yellow { background: rgba(205, 181, 63, 0.5); }
.risk-levels .amber { background: rgba(170, 120, 46, 0.52); }
.risk-levels .red { background: rgba(173, 75, 62, 0.54); }

.business-class {
  padding: 22px 26px;
  background: rgba(0, 49, 43, 0.62);
  border: 1px solid rgba(117, 255, 241, 0.48);
}

.business-class div {
  display: grid;
  grid-template-columns: 150px 1fr;
  align-items: center;
  margin-top: 20px;
  padding: 20px 14px;
  background: rgba(8, 92, 80, 0.62);
  border-radius: 6px;
}

.business-class span {
  color: #ffffff;
  font-size: 28px;
  font-weight: 900;
}

.delivery-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 28px;
}

.delivery-box p {
  margin-bottom: 20px;
  color: #ffffff;
  font-weight: 900;
}

.disposal-flow {
  min-height: 0;
  // display: grid;
  // grid-template-columns: repeat(6, 1fr);
  // grid-template-rows: 1fr 1fr;
  // gap: 34px 28px;
  // align-items: center;
  img{
    width: 100%;
  }
}

.step-card {
  min-height: 150px;
  padding: 28px 22px;
  text-align: center;
  clip-path: polygon(22px 0, calc(100% - 22px) 0, 100% 22px, 100% calc(100% - 22px), calc(100% - 22px) 100%, 22px 100%, 0 calc(100% - 22px), 0 22px);
}

.top-step {
  grid-column: span 2;
}

.wide-step {
  grid-column: span 3;
  min-height: 160px;
}
.right-panel{
  width: 2500px;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 650px 1fr;
  // gap:0 24px;
  // align-items: center;
}
</style>
